module.exports = __webpack_public_path__ + "static/media/social_respon_cn1.16523bcc.png";